// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__mOMLJ","toggle":"Toggle_toggle___jf45","primary":"Toggle_primary__u1gMf","theme":"Toggle_theme__SC7_Y"};